import React from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import "../../../src/css/Common/EnquiryModal.css"

export default function EnquiryModal({
    isOpen,
    toggle,
    items = [],
    remark,
    setRemark,
    onRemoveItem,
    onSubmit,
    submitting = false,
    title = "Product Enquiry"
}) {
    const renderHeader = () => (
        <div className="d-flex justify-content-between align-items-center w-100">
            <span className="fw-bold">{title} ({items.length} {items.length === 1 ? 'item' : 'items'})</span>
        </div>
    );

    const renderFooter = () => (
        <div className="d-flex justify-content-end align-items-center gap-3 p-3 border-top bg-light rounded-bottom">
            <div>
                <Button 
                    label="Cancel" 
                    icon="pi pi-times" 
                    onClick={toggle} 
                    className="btn-cart-outline w-100 py-2"
                    style={{fontSize: "13px"}}
                    disabled={submitting}
                />
            </div>
            <div>
                <Button 
                    label={submitting ? "Submitting" : "Submit"} 
                    icon={submitting ? "pi pi-spin pi-spinner" : "pi pi-check"} 
                    onClick={onSubmit} 
                    disabled={submitting || items.length === 0} 
                    className="btn-primary w-100 py-2"
                    loading={submitting}
                />
            </div>
        </div>
    );

    return (
        <Dialog 
            header={renderHeader()} 
            footer={renderFooter()} 
            visible={isOpen} 
            style={{ width: '50vw' }} 
            onHide={toggle}
            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
            modal
            draggable={false}
            resizable={false}
            className="enquiry-dialog-custom"
            contentClassName="bg-white p-3"
            headerClassName="bg-white border-bottom p-3 rounded-top"
        >
            <div className="row g-3 enquiry-card-row p-1">
                {items.map(item => (
                    <div className="col-md-12 col-lg-6" key={item.Style_ID}>
                        <div className="card h-100 position-relative bg-white rounded-3 shadow-sm border border-light-subtle transition-hover">
                            {items.length > 1 && (
                                <button 
                                    className="btn btn-link position-absolute top-0 end-0 p-2 m-1 text-muted hover-red text-decoration-none border-0 bg-transparent" 
                                    onClick={() => onRemoveItem(item.Style_ID)}
                                    title="Remove item"
                                > 
                                    <i className="pi pi-trash" style={{ fontSize: '0.8rem' }}></i>
                                </button>
                            )}
                            <div className="card-body p-3">
                                <h6 className="fw-bold mb-2 text-primary text-truncate pe-4" title={item.Shortdescription}>
                                    {item.Shortdescription}
                                </h6>
                                <div className="detail-row small mb-1 d-flex flex-wrap">
                                    <span className="fw-semibold text-secondary me-1">Code:</span>
                                    <span className="text-dark">{item.StyleNo} / {item.JewelCode}</span>
                                </div>
                                <div className="detail-row small mb-1 d-flex flex-wrap">
                                    <span className="fw-semibold text-secondary me-1">Details:</span>
                                    <span className="text-dark">{item.MetalQuality} / {item.MetalTone}</span>
                                </div>
                                <div className="detail-row small d-flex flex-wrap">
                                    <span className="fw-semibold text-secondary me-1">Weight:</span>
                                    <span className="text-dark">{item.TotalNetWt}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            
            <div className="Enquiry-form mt-4">
                <div className="field">
                    <label htmlFor="remark" className="form-label fw-semibold text-secondary mb-2 d-block">
                        Remark
                    </label>
                    <InputTextarea
                        id="remark"
                        className="w-100 border-2 shadow-sm rounded-3 p-3 focus-primary"
                        style={{ width: '100%' }}
                        rows={3}
                        placeholder="Type any additional information or specific requirements here..."
                        value={remark}
                        autoResize
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^a-zA-Z0-9\s.,!-]/g, "");
                            if (value.length <= 50) {
                                setRemark(value);
                            }
                        }}
                    />
                    <div className="d-flex justify-content-end mt-1">
                        <small className={`fw-medium font-monospace ${remark.length === 50 ? 'text-danger' : 'text-muted'}`}>
                            {remark.length}/50
                        </small>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
